import { render, staticRenderFns } from "./AddRule.vue?vue&type=template&id=32f8a394&scoped=true"
import script from "./AddRule.vue?vue&type=script&lang=js"
export * from "./AddRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f8a394",
  null
  
)

export default component.exports